import AbstractModel from './AbstractModel';

class LookupValueModel extends AbstractModel {}

export default LookupValueModel;
